export const Color = {
  grey: {
    /* Grey/White */
    100: "#ffffff",
    /* Grey/Cotton */
    200: "#fbfbfb",
    /* Grey/Paper */
    300: "#f7f7f7",
    /* Grey/Canvas */
    400: "#dfe0e1",
    /* Grey/Graphite */
    700: "#757575",
    /* Grey/FaireBlack */
    900: "#333333",
    /* Grey/Black */
    1000: "#000000",
  },
  neutral: {
    /* Neutral/Ivory */
    100: "#fbf8f6",
    /* Neutral/Flax */
    600: "#b5a998",
    /* Neutral/Espresso */
    1000: "#585550",
  },
  red: {
    /* Red/Blossom */
    100: "#f2e5e1",
    /* Red/Almond */
    200: "#e9e0dc",
    /* Red/Sugar */
    400: "#ba9b88",
    /* Red/Rose */
    500: "#d17e70",
    /* Red/Siren */
    700: "#921100",
    /* Red/Brick */
    800: "#5a1e09",
    /* Red/Eggplant */
    1000: "#390d18",
  },
  blue: {
    /* Blue/Salt */
    100: "#f2f5f5",
    /* Blue/Thistle */
    200: "#e2e7f0",
    /* Blue/Taro */
    400: "#7a7885",
    /* Blue/Jay */
    500: "#667495",
    /* Blue/Blueberry */
    700: "#275ec5",
    /* Blue/Midnight */
    1000: "#1b2834",
  },
  teal: {
    /* Teal/Harbor */
    600: "#36676a",
    /* Teal/Pacific */
    900: "#154548",
  },
  orange: {
    /* Orange/Ecru */
    100: "#f6eee4",
    /* Orange/Terra */
    400: "#ab7456",
    700: "#e65126",
    /* Orange/Rust */
    1000: "#7d3e1e",
  },
  yellow: {
    /* Yellow/Meringue */
    100: "#f6efdb",
    /* Yellow/Sand */
    200: "#ece3d2",
    /* Yellow/Cashew */
    400: "#d1b985",
    /* Yellow/Bamboo */
    600: "#a79764",
    /* Yello/Dijon */
    800: "#907c3a",
    /* Yellow/Marsh */
    1000: "#595540",
  },
  green: {
    /* Green/Soy */
    100: "#e9f1e5",
    /* Green/Ivy */
    200: "#dde3d0",
    /* Green/Birch */
    300: "#d9d8cd",
    /* Green/Field */
    500: "#91957b",
    /* Green/Juniper */
    600: "#91a793",
    /* Green/Fern */
    700: "#49694c",
    /* Green/Thyme */
    1000: "#3e4023",
  },
  transparent: {
    grey: {
      100: "rgba(51, 51, 51, 0.05)",
      200: "rgba(51, 51, 51, 0.1)",
      500: "rgba(51, 51, 51, 0.5)",
    },
  },
} as const;
